import React from "react"
import * as PropTypes from "prop-types";
import styled from "styled-components"

import Menu from "../menu/menu";
import LogoShort from "../../../static/svg/logo-short.svg";
import {InternalLink, MaxWidthContainer} from "../../style/itf-styled-components";

const Logo = styled(LogoShort)`
  fill: ${props => props.theme.colors.secondary.base};
  height: 56px;
`;

const DesktopHeader = ({className, page}) => (
  <div css={`
    display: flex;
    justify-content: center;
    max-height: 88px;
    background-color: ${props => props.theme.colors.neutrals._000};
    position: relative;
    width: 100%;
  `}
     className={className}
  >
    <InternalLink css={`
      position: absolute;
      left: 25px;
      top: 50%;
      margin-top: -28px;
    `}
      to="/"
    >
      <Logo/>
    </InternalLink>
    <MaxWidthContainer css={`
      @media (max-width: 1350px) {
        padding-left: 100px;
      }
    `}
    >
      <Menu css={`
        display: flex;
        justify-content: flex-start;
      `}
        page={page}
      />
    </MaxWidthContainer>
  </div>
);

DesktopHeader.propTypes = {
  page: PropTypes.string.isRequired
};

export default DesktopHeader
